module.exports = "<div class=\"wrapper-full-page\">\n <div class=\"main-centered\">\n  <div class=\"row\">\n   <div class=\"col-md-12\">\n    <div class=\"text-center\">\n     <i class=\"fa fa-exclamation-triangle\"></i>\n     <h1>Erro 403</h1>\n    </div>\n    <div class=\"text-center\">\n     <h3>Você não tem permissão para acessar este conteúdo!</h3>\n     <br />\n     <a [routerLink]=\"link\" class=\"btn btn-primary\">{{ 'Back' | translate }}</a>\n    </div>\n   </div>\n  </div>\n </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/pages/forbidden.component.html
// module id = ./src/app/modules/shared/pages/forbidden.component.html
// module chunks = main